import { Logger } from 'src/core/logger/logger';
import { CHECKOUT_COLUMNS } from 'src/config/app.config';
import { CheckoutBreakdownTypeEnum } from 'src/core/model/enum/checkout-breakdown-type.enum';
import { CheckoutModel } from 'src/core/model/quarter-overview.model';
import { csvStringToFloat } from '../quarter-overview.utils';

type ParsedCheckoutHeaders = Required<Record<keyof CheckoutModel, number>>;

export function parseCheckoutHeader(line: any[]): ParsedCheckoutHeaders {
  const headers = Object.entries(CHECKOUT_COLUMNS);

  const result: ParsedCheckoutHeaders = {
    breakdownType: -1,
    iTransactionId: -1,
    totalHT: -1,
  };

  headers.forEach(([key, value]) => {
    const colIndex = line.findIndex((item) => item === value);

    if (colIndex < 0) {
      Logger.error(`[CHECKOUT-FILE]: Column ${value} not found.`);
      return;
    }

    result[key as keyof CheckoutModel] = colIndex;
  });

  return result;
}

export function parseCheckoutLine(
  line: any[],
  config: ParsedCheckoutHeaders,
): CheckoutModel {
  const result: CheckoutModel = {
    iTransactionId:
      config.iTransactionId >= 0 ? line[config.iTransactionId] : '',
    ...(config.totalHT >= 0 && {
      totalHT: csvStringToFloat(line[config.totalHT]),
    }),
    ...(config.breakdownType >= 0 && {
      breakdownType: line[config.breakdownType] as CheckoutBreakdownTypeEnum,
    }),
  };

  if (result.breakdownType) {
    const expectedBreakdownType = Object.values(CheckoutBreakdownTypeEnum);

    if (!expectedBreakdownType.includes(result.breakdownType)) {
      Logger.warn(
        `[CHECKOUT-FILE]: Unknown breakdownType, received: ${result.breakdownType}`,
      );
    }
  }

  return result;
}

export function parseCheckout(header: any[], lines: any[]): CheckoutModel[] {
  const checkoutHeaders = parseCheckoutHeader(header);
  return lines.map((item) => parseCheckoutLine(item, checkoutHeaders));
}
